export const REMIND_ME_LATER_LOCAL_STORAGE_KEY = 'announcements.reminderlatercontentids';
